import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { TableConfig } from "../../types/Components/Table/TableConfig";
import {
  renderEmptyState,
  renderErrorState,
  renderLoadingState,
} from "./TableStates";

const useTableRendering = (
  tableConfig: TableConfig,
  pageSize: number,
  totalItems?: number,
  setIsPaginationBE?: Dispatch<SetStateAction<boolean>>,
) => {
  const {
    dataTable,
    isLoaded = true,
    errorFindingData,
    setErrorFindingData,
    renderTable,
  } = tableConfig;

  const [refreshTable, setRefreshTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = totalItems
    ? Math.ceil(totalItems / pageSize)
    : Math.ceil(dataTable.length / pageSize);

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    if (totalPages < currentPage && totalPages > 0) {
      setCurrentPage(totalPages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalPages]);

  useEffect(() => {
    if (setIsPaginationBE) {
      setIsPaginationBE(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, currentPage]);

  useEffect(() => {
    setErrorFindingData && setErrorFindingData(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTable]);

  const handleRefresh = () => {
    setRefreshTable((prev) => !prev);
  };

  const renderContent = () => {
    if (errorFindingData) return renderErrorState(handleRefresh);
    if (!isLoaded) return renderLoadingState();

    let currentPageData = dataTable;

    if (!setIsPaginationBE) {
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = Math.min(startIndex + pageSize, dataTable.length);
      currentPageData = dataTable.slice(startIndex, endIndex);
    }

    return currentPageData.length > 0
      ? renderTable(currentPageData)
      : renderEmptyState();
  };

  return {
    currentPage,
    totalPages,
    handlePageChange,
    renderContent,
  };
};

export default useTableRendering;
